// extracted by mini-css-extract-plugin
export default {"loading":"yc__pJ"};